import React from 'react';
import tw from 'twin.macro';
import clsx from 'clsx';

type MaxWidthSize = 'xl' | 'lg' | 'md' | 'sm' | 'responsive';

interface Props {
  children: React.ReactNode;
  maxWidth?: MaxWidthSize;
  className?: string;
  lightPadding?: boolean;
  withMargin?: boolean;
}

export function SingleCardPage(props: Props) {
  const { maxWidth, children, className, lightPadding, withMargin } = props;
  return (
    <div
      css={[
        tw`mt-8 sm:w-full sm:max-w-md sm:min-w-[28rem]`,
        withMargin ? tw`mx-4` : tw`sm:mx-auto`,
        maxWidth === 'xl' && tw`sm:max-w-5xl sm:min-w-[64rem]`,
        maxWidth === 'lg' && tw`sm:max-w-2xl sm:min-w-[42rem]`,
        maxWidth === 'md' && tw`sm:max-w-lg sm:min-w-[32rem]`,
        maxWidth === 'sm' && tw`sm:max-w-xs sm:min-w-[20rem]`,
        maxWidth === 'responsive' &&
          tw`md:max-w-lg md:min-w-[32rem] lg:max-w-2xl lg:min-w-[54rem] xl:max-w-5xl xl:min-w-[64rem]`,
      ]}
    >
      <div
        className={clsx(className)}
        css={[
          tw`bg-white shadow`,
          lightPadding ? tw`px-4 pt-6 pb-10 lg:px-6` : tw`py-8 px-4 sm:px-10`,
          withMargin ? tw`rounded-lg` : tw`sm:rounded-lg`,
        ]}
      >
        {children}
      </div>
    </div>
  );
}
